/**
 * Systems
 * System Reports
 * Sysops
 * Sysadmins
 * Sysusers
 *
 * GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, CREATE, UPDATE, DELETE
 */
export const RESOURCES = {
    "Systems": {
        GET_LIST: function (params) {
            return {
                "type": "list",
                "method": "GET",
                "title": "Systems",
                "uri": localStorage.getItem('server') + "/api/v5/op/subscriber/getAll?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            if (params && params.id) {
                params.name = params.id;
            }
            return {
                "type": "item",
                "method": "GET",
                "title": "System",
                "uri": localStorage.getItem('server') + "/api/v5/op/subscriber/get/" + params.name
            }
        },
        CREATE: function (params) {
            let systemParams = populateSystemParams(params);
            return {
                "type": "upsert",
                "data": systemParams.data,
                "uri": localStorage.getItem('server') + "/api/v5/op/subscriber/set"
            }
        },
        UPDATE: function (params) {
            let systemParams = populateSystemParams(params);
            return {
                "type": "upsert",
                "data": systemParams.data,
                "uri": localStorage.getItem('server') + "/api/v5/op/subscriber/set"
            }
        },
    },
    "SystemsReportUsage": {
        GET_LIST: function (params) {
            let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "Systems Report Usage",
                "uri": localStorage.getItem('server') + "/api/v5/report/sysop/locationDeviceReportsHandler/" + startEndOffset
            }
        }
    },
    "SystemsReportGetAll": {
        GET_LIST: function () {
            return {
                "type": "list",
                "method": "GET",
                "title": "Systems Report Get All",
                "uri": localStorage.getItem('server') + "/api/v5/op/subscriber/getAll"
            }
        }
    },
    "Sysops": {
        GET_LIST: function (params) {
            return {
                "type": "list",
                "method": "GET",
                "title": "System Operators",
                "uri": localStorage.getItem('server') + "/api/v5/op/user/getAll?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            if (params) {
                if (params.id) {
                    params.email = params.id;
                }
                if (params.sys_email) {
                    params.email = params.sys_email;
                }
            }
            return {
                "type": "item",
                "method": "GET",
                "title": "System Operator",
                "uri": localStorage.getItem('server') + "/api/v5/op/user/get/" + params.email
            }
        },
        CREATE: function (params) {
            let sysopParams = populateSysopParams(params);
            return {
                "type": "upsert",
                "data": sysopParams.data,
                "uri": localStorage.getItem('server') + "/api/v5/op/user/set"
            }
        },
        UPDATE: function (params) {
            let sysopParams = populateSysopParams(params);
            return {
                "type": "upsert",
                "data": sysopParams.data,
                "uri": localStorage.getItem('server') + "/api/v5/op/user/set"
            }
        },
    },
    "Sysadmins": {
        GET_LIST: function (params) {
            return {
                "type": "list",
                "method": "GET",
                "title": "System Administrators",
                "uri": localStorage.getItem('server') + "/api/v5/op/user/getAll?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            if (params) {
                if (params.id) {
                    params.email = params.id;
                }
                if (params.sys_email) {
                    params.email = params.sys_email;
                }
            }
            return {
                "type": "item",
                "method": "GET",
                "title": "System Administrator",
                "uri": localStorage.getItem('server') + "/api/v5/op/user/get/" + params.email
            }
        },
        CREATE: function (params) {
            let sysadminParams = populateSysadminParams(params);
            return {
                "type": "upsert",
                "data": sysadminParams.data,
                "uri": localStorage.getItem('server') + "/api/v5/op/user/set"
            }
        },
        UPDATE: function (params) {
            let sysadminParams = populateSysadminParams(params);
            return {
                "type": "upsert",
                "data": sysadminParams.data,
                "uri": localStorage.getItem('server') + "/api/v5/op/user/set"
            }
        },
    },
    "Sysusers": {
        GET_LIST: function (params) {
            return {
                "type": "list",
                "method": "GET",
                "title": "System Users",
                "uri": localStorage.getItem('server') + "/api/v5/op/user/getAll?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            if (params) {
                if (params.id) {
                    params.email = params.id;
                }
                if (params.sys_email) {
                    params.email = params.sys_email;
                }
            }
            return {
                "type": "item",
                "method": "GET",
                "title": "System User",
                "uri": localStorage.getItem('server') + "/api/v5/op/user/get/" + params.email
            }
        },
        CREATE: function (params) {
            let sysadminParams = populateSysuserParams(params);
            return {
                "type": "upsert",
                "data": sysadminParams.data,
                "uri": localStorage.getItem('server') + "/api/v5/op/user/set"
            }
        },
        UPDATE: function (params) {
            let sysadminParams = populateSysuserParams(params);
            return {
                "type": "upsert",
                "data": sysadminParams.data,
                "uri": localStorage.getItem('server') + "/api/v5/op/user/set"
            }
        },
    }
};

/*
 * Populate values for Systems and remove objects
 */
const populateSystemParams = (params) => {
    // Populate the display Name as the Name if not added
    if ((!params.data.display_name || params.data.display_name === '')) {
        params.data.display_name = params.data.name;
    }
    // Overwrite the password if applicable and valid
    const new_password = params.data.sys_new_password;
    if (new_password && new_password !== '' && new_password !== 'REDACTED' && new_password === params.data.sys_confirm_new_password) {
        params.data.password = new_password;
        delete params.data.sys_new_password;
        delete params.data.sys_confirm_new_password;
    } else if (params.data.sys_password) {
        params.data.password = params.data.sys_password;
    }
    delete params.data.sys_password;
    delete params.data.sys_confirm_password;

    return params;
};

/*
 * Populate values for Sysops and remove objects
 */
const populateSysopParams = (params) => {
    if (params.data.systems_all === true || (params.data.systems && !params.data.systems.length)) {
        delete params.data.systems;
    }
    if (params.data.sections_all === true || (params.data.sections && !params.data.sections.length)) {
        delete params.data.sections;
    }
    if (params.data.locations_all === true || (params.data.locations && !params.data.locations.length)) {
        delete params.data.locations;
    }
    if (params.data.dbas_all === true || (params.data.dbas && !params.data.dbas.length)) {
        delete params.data.dbas;
    }
    if (params.data.districts_all === true || (params.data.districts && !params.data.districts.length)) {
        delete params.data.districts;
    }
    // Set email field
    if (params.data.sys_email) {
        params.data.email = params.data.sys_email;
        delete params.data.sys_email;
    }
    if (params.data.sys_email_check) {
        delete params.data.sys_email_check;
    }
    // Overwrite the password if applicable and valid
    const new_password = params.data.sys_new_password;
    if (new_password && new_password !== '' && new_password !== 'REDACTED' && new_password === params.data.sys_confirm_new_password) {
        params.data.password = new_password;
        delete params.data.sys_new_password;
        delete params.data.sys_confirm_new_password;
    } else if (params.data.sys_password) {
        params.data.password = params.data.sys_password;
    }
    delete params.data.sys_password;
    delete params.data.sys_confirm_password;
    // Set name
    if (params.data.sys_first_name) {
        params.data.first_name = params.data.sys_first_name;
        delete params.data.sys_first_name;
    }
    if (params.data.sys_last_name) {
        params.data.last_name = params.data.sys_last_name;
        delete params.data.sys_last_name;
    }
    delete params.data.id;
    delete params.data.sys_id;

    return params;
};

/*
 * Populate values for Sysadmins and remove objects
 */
const populateSysadminParams = (params) => {
    if (params.data.systems_all === true || (params.data.systems && !params.data.systems.length)) {
        delete params.data.systems;
    }
    if (params.data.sections_all === true || (params.data.sections && !params.data.sections.length)) {
        delete params.data.sections;
    }
    if (params.data.locations_all === true || (params.data.locations && !params.data.locations.length)) {
        delete params.data.locations;
    }
    if (params.data.dbas_all === true || (params.data.dbas && !params.data.dbas.length)) {
        delete params.data.dbas;
    }
    if (params.data.districts_all === true || (params.data.districts && !params.data.districts.length)) {
        delete params.data.districts;
    }
    // Set email field
    if (params.data.sys_email) {
        params.data.email = params.data.sys_email;
        delete params.data.sys_email;
    }
    if (params.data.sys_email_check) {
        delete params.data.sys_email_check;
    }
    // Overwrite the password if applicable and valid
    const new_password = params.data.sys_new_password;
    if (new_password && new_password !== '' && new_password !== 'REDACTED' && new_password === params.data.sys_confirm_new_password) {
        params.data.password = new_password;
        delete params.data.sys_new_password;
        delete params.data.sys_confirm_new_password;
    } else if (params.data.sys_password) {
        params.data.password = params.data.sys_password;
    }
    delete params.data.sys_password;
    delete params.data.sys_confirm_password;
    // Set name
    if (params.data.sys_first_name) {
        params.data.first_name = params.data.sys_first_name;
        delete params.data.sys_first_name;
    }
    if (params.data.sys_last_name) {
        params.data.last_name = params.data.sys_last_name;
        delete params.data.sys_last_name;
    }
    delete params.data.id;
    delete params.data.sys_id;

    return params;
};

/*
 * Populate values for Sysusers and remove objects
 */
const populateSysuserParams = (params) => {
    params.data.systems_all = false;
    if (params.data.sections_all === true || (params.data.sections && !params.data.sections.length)) {
        delete params.data.sections;
    }
    if (params.data.locations_all === true || (params.data.locations && !params.data.locations.length)) {
        delete params.data.locations;
    }
    if (params.data.dbas_all === true || (params.data.dbas && !params.data.dbas.length)) {
        delete params.data.dbas;
    }
    if (params.data.districts_all === true || (params.data.districts && !params.data.districts.length)) {
        delete params.data.districts;
    }
    // Set email field
    if (params.data.sys_email) {
        params.data.email = params.data.sys_email;
        delete params.data.sys_email;
    }
    if (params.data.sys_email_check) {
        delete params.data.sys_email_check;
    }
    // Overwrite the password if applicable and valid
    const new_password = params.data.sys_new_password;
    if (new_password && new_password !== '' && new_password !== 'REDACTED' && new_password === params.data.sys_confirm_new_password) {
        params.data.password = new_password;
        delete params.data.sys_new_password;
        delete params.data.sys_confirm_new_password;
    } else if (params.data.sys_password) {
        params.data.password = params.data.sys_password;
    }
    delete params.data.sys_password;
    delete params.data.sys_confirm_password;
    // Set name
    if (params.data.sys_first_name) {
        params.data.first_name = params.data.sys_first_name;
        delete params.data.sys_first_name;
    }
    if (params.data.sys_last_name) {
        params.data.last_name = params.data.sys_last_name;
        delete params.data.sys_last_name;
    }
    delete params.data.id;
    delete params.data.sys_id;

    return params;
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "Sysadmins"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseSystemsResourceMap.js